<template>
		<Dashboard/>
</template>

<script>
// @ is an alias to /src
import Dashboard from '@/components/dashboard/Dashboard.vue'

export default {
  name: 'dashboard',
  components: {
    Dashboard
  }
}
</script>
